import React from "react";
import "./cards.css";
import CardItem from "./Carditem";
import About from "./About"
import Footer from "./Footer"
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/custom-animations/cube-animation.css';
import 'react-awesome-slider/dist/styles.css';
function Cards() {
  return (
    <div className="cards">
      <About />
      <div id='services' className="ourservices">
        <h1 style={{ fontSize: '50px', fontFamily: "Arial Black, sans-serif" }}>Our Services</h1>
        <div className="cards__coasdntainer">
          {window.innerWidth < 600 ? <>
            <AwesomeSlider>
              <div className="">
                <CardItem
                  src={require("../images/inspecttion.png")}
                  text="We have field service teams available around the world to travel to your aircraft. With representatives in Dubai, the United Kingdom, and India, we can provide rapid response times and cost-effective support for your project."
                  label="BOROSCOPE INSPECTION"
                  path="#"
                /></div>
              <div className="">
                <CardItem
                  src={require("../images/thrust.jpg")}
                  text="We specialize in pre and post lease Thrust Reverser & Nacelle Inspections on-site. Following the onsite inspection, we will provide a debrief highlighting any findings made during the inspection. We provide a detailed report that includes photographs of the damage as well as an AMM-based damage map that shows the location of any findings."
                  label="THRUST REVERSER & NACELLE INSPECTIONS"
                  path="#"
                /></div>
              <div className="">
                <CardItem
                  src={require("../images/aero.jpg")}
                  text="Technical representatives from FLYXAVI Solutions LLP(s) make decisions during aircraft maintenance inputs, engine shop visits, landing gear shop visits, borescope inspections, and so on. The presence of a representative aids in the control and speeding up of any process involving the asset, its major components, shop visits, maintenance inputs, and so on."
                  label="TECHNICAL REPRESENTATION"
                  path="#"
                /></div>
              <div className="">
                <CardItem
                  src={require("../images/aero.jpg")}
                  text="Technical representatives from FLYXAVI Solutions LLP(s) make decisions during aircraft maintenance inputs, engine shop visits, landing gear shop visits, borescope inspections, and so on. The presence of a representative aids in the control and speeding up of any process involving the asset, its major components, shop visits, maintenance inputs, and so on."
                  label="TECHNICAL REPRESENTATION"
                  path="#"
                /></div>
              <div className="">
                <CardItem
                  src={require("../images/reception.png")}
                  text='We specialize in pre and post-lease Thrust Reverser & Nacelle Inspections on-site. Following the onsite inspection, we will provide a debrief highlighting any findings made during the inspection. We provide a detailed report that includes photographs of the damage as well as an AMM-based damage map that shows the location of any findings.'
                  label='THRUST REVERSER & NACELLE INSPECTIONS'
                  path='#'
                /></div>
              <div className="">
                <CardItem
                  src={require("../images/management.png")}
                  text='Technical representatives from FLYXAVI Solutions LLP(s) make decisions during aircraft maintenance inputs, engine shop visits, landing gear shop visits, borescope inspections, and so on. The presence of a representative aids in the control and speeding up of any process involving the asset, its major components, shop visits, maintenance inputs, and so on.'
                  label='TECHNICAL REPRESENTATION'
                  path='#'
                /></div>
            </AwesomeSlider>
          </> : <><AwesomeSlider>
            <div className="cards">
              <CardItem
                src={require("../images/inspecttion.png")}
                text="We have field service teams available around the world to travel to your aircraft. With representatives in Dubai, the United Kingdom, and India, we can provide rapid response times and cost-effective support for your project."
                label="BOROSCOPE INSPECTION"
                path="#"
              />
              <CardItem
                src={require("../images/thrust.jpg")}
                text="We specialize in pre and post-lease Thrust Reverser & Nacelle Inspections on-site. Following the onsite inspection, we will provide a debrief highlighting any findings made during the inspection. We provide a detailed report that includes photographs of the damage as well as an AMM-based damage map that shows the location of any findings."
                label="THRUST REVERSER & NACELLE INSPECTIONS"
                path="#"
              />
              <CardItem
                src={require("../images/aero.jpg")}
                text="Technical representatives from FLYXAVI Solutions LLP(s) make decisions during aircraft maintenance inputs, engine shop visits, landing gear shop visits, borescope inspections, and so on. The presence of a representative aids in the control and speeding up of any process involving the asset, its major components, shop visits, maintenance inputs, and so on."
                label="TECHNICAL REPRESENTATION"
                path="#"
              />
            </div>
            <div className="cards">
              <CardItem
                src={require("../images/aero.jpg")}
                text="Technical representatives from FLYXAVI Solutions LLP(s) make decisions during aircraft maintenance inputs, engine shop visits, landing gear shop visits, borescope inspections, and so on. The presence of a representative aids in the control and speeding up of any process involving the asset, its major components, shop visits, maintenance inputs, and so on."
                label="TECHNICAL REPRESENTATION"
                path="#"
              />
              <CardItem
                src={require("../images/reception.png")}
                text='We specialize in pre and post-lease Thrust Reverser & Nacelle Inspections on-site. Following the onsite inspection, we will provide a debrief highlighting any findings made during the inspection. We provide a detailed report that includes photographs of the damage as well as an AMM-based damage map that shows the location of any findings.'
                label='THRUST REVERSER & NACELLE INSPECTIONS'
                path='#'
              />
              <CardItem
                src={require("../images/management.png")}
                text='Technical representatives from FLYXAVI Solutions LLP(s) make decisions during aircraft maintenance inputs, engine shop visits, landing gear shop visits, borescope inspections, and so on. The presence of a representative aids in the control and speeding up of any process involving the asset, its major components, shop visits, maintenance inputs, and so on.'
                label='TECHNICAL REPRESENTATION'
                path='#'
              /></div>
          </AwesomeSlider></>}

        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Cards;